import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import RemoveISTSubtemplateCommand from "./removeistsubtemplatecommand";

export default class RemoveISTSubtemplateEditing extends Plugin {
  init() {
    const editor = this.editor;
    editor.commands.add(
      "removeistsubtemplate",
      new RemoveISTSubtemplateCommand(editor)
    );
  }
}